const thousandSeparated = (num: any) => {
  const converted = num.toLocaleString().replaceAll(",", ".");
  return converted;
};

export default thousandSeparated;
